<template>

  <div class="hello">
    <ui-modal ref="err_modal" title="Messages">
      <ui-alert type="error" :dismissible="false" v-if="messagesErreur.length > 0">
        <ul v-if="messagesErreur.length > 0">
          <li  v-for="item in messagesErreur" :key="item" >
            {{item}}
          </li >
        </ul>
      </ui-alert>


      <div  v-if="messagesErreur.length <= 0">
        <ui-alert type="success" :dismissible="false">
                        {{messageSucces}}
        </ui-alert>
      </div>
    </ui-modal>
<div v-if='!addMode || choixPersonne'>
<table>
<tr>
  <td><ui-textbox label="Id" placeholder="" v-model="formPersonne.id"></ui-textbox></td>
  <td><ui-textbox label="Nom" placeholder="" v-model="formPersonne.nom"></ui-textbox></td>
  <td><ui-textbox label="Cin/Passport" placeholder="" v-model="formPersonne.cin"></ui-textbox></td>
  <td><ui-textbox label="Tel" placeholder="" v-model="formPersonne.tel"></ui-textbox></td>
  <td><ui-textbox label="Email" placeholder="" v-model="formPersonne.email"></ui-textbox></td>
</tr>
</table>



<ui-button :color="'green'" @click="chercher()">Chercher</ui-button>
<ui-button :color="'red'" @click="retourPersonne" v-if="choixPersonne" style="margin-left:5px;">Retour</ui-button>
<ui-button :color="'red'" @click="showFormAdd()" v-if="!choixPersonne" style="margin-left:5px;">Nouvelle Personne</ui-button>

<div v-if="hasNext || hasPrevious">
  <br>
  <ui-button :color="'green'" @click="precedent()" :disabled="!hasPrevious">Precedent</ui-button>
  <ui-button :color="'green'" @click="suivant()" :disabled="!hasNext">Suivant</ui-button>

</div>


<b-table striped hover :items="listSearch" :fields="fields">
  <!-- A virtual column -->

  <template #cell(actions)="data">
      <div v-if="!choixPersonne">
        <ui-button :color="'red'" @click="update(data)">Modifier</ui-button>
      </div>
      <div v-if="choixPersonne" style="margin-left:5px;">
        <ui-button :color="'red'" @click="choisirPersonne(data)">Choisir</ui-button>

      </div>
  </template>

</b-table>


</div>
<div v-if='addMode  && !choixAssure && !choixPersonne && !choixFormBeneficiere'>
  <div style="width:50%">
    <span>Id : {{formPersonne.id}}</span>
    <ui-textbox label="Nom" placeholder="" v-model="formPersonne.nom"></ui-textbox>
    <ui-textbox label="Prenom" placeholder="" v-model="formPersonne.prenom"></ui-textbox>

    <ui-select
                 name="nationalite"
                 :options="listNationalities"
                 :keys="{ label: 'libelle', value: 'id' }"
                 v-model="formPersonne.nationalite"

                 >nationalite</ui-select>

    <ui-select
                 name="typeIdentite"
                 :options="listTypeIdentities"
                 :keys="{ label: 'libelle', value: 'id' }"
                 v-model="formPersonne.typeIdentite"

                 >Type du document d'identite</ui-select>

    <ui-textbox label="Cin/Passport" placeholder="" v-model="formPersonne.cin"></ui-textbox>
    <ui-textbox label="Adresse" placeholder="" v-model="formPersonne.adresse"></ui-textbox>
    <ui-textbox label="Addresse Principale" placeholder="" v-model="formPersonne.addressPrincipale"></ui-textbox>
    <ui-textbox label="Tel" placeholder="" v-model="formPersonne.tel"></ui-textbox>
    <ui-textbox label="Email" placeholder="" v-model="formPersonne.email"></ui-textbox>
    <ui-datepicker placeholder="" v-model="formPersonne.dateNaissance" required>Date de Naissance</ui-datepicker>
    <td><ui-checkbox v-model="formPersonne.salarie">Salarie</ui-checkbox></td>
  </div>

  <br/>
  <br/>
  <br/>

     <div>
          <ui-button :color="'green'" @click="choisirBeneficiere()">Ajouter Beneficiere</ui-button>
          <b-table striped hover :items="formPersonne.beneficieres" :fields="fieldsBeneficiere">

            <template #cell(lienParente)="data">

              <ui-select
                  label=""
                  placeholder=""
                  :options="listLienParente"
                  :keys="{ label: 'libelle', value: 'id' }"
                  v-model="formPersonne.beneficieres[data.index].lienParente"
              ></ui-select>

            </template>

            <!-- A virtual column -->
            <template #cell(actions)="data">
                  <ui-button :color="'red'" @click="supprimerBeneficiere(data)">Supprimer</ui-button>
            </template>

          </b-table>


       </div>

      <br/>


  <ui-button :color="'green'" @click="enregistrer()">Enregistrer</ui-button>
  <ui-button :color="'red'" @click="annuler()" style="margin-left:5px;">Retour</ui-button>

</div>


<div v-if="choixFormBeneficiere">

    <b-card>
      <table>
         <tr>
           <td>Id</td>
           <td> : {{formBeneficiere.beneficiere.id}}</td>
         </tr>
         <tr>
           <td>Nom</td>
           <td> : {{formBeneficiere.beneficiere.nom}}</td>
         </tr>
         <tr>
           <td>PreNom</td>
           <td> : {{formBeneficiere.beneficiere.prenom}}</td>
         </tr>
         <tr>
           <td>Cin/Passport</td>
           <td> : {{formBeneficiere.beneficiere.cin}}</td>
         </tr>
         <tr>
           <td>Telephone</td>
           <td> : {{formBeneficiere.beneficiere.tel}}</td>
         </tr>
         <tr>
           <td>Email</td>
           <td> : {{formBeneficiere.beneficiere.email}}</td>
         </tr>
         <tr>
          <td>
            <ui-select
                label="Lien de parente"
                placeholder=""
                :options="listLienParente"
                :keys="{ label: 'libelle', value: 'id' }"
                v-model="formBeneficiere.lienParente"
            ></ui-select>
          </td>
         </tr>


       </table>
       <ui-button :color="'green'" @click="ajouterBeneficiere">Ajouter</ui-button>
       <ui-button :color="'green'" @click="annulerAjoutBeneficiere" style="margin-left:5px;">Annuler</ui-button>

     </b-card>

 </div>


<div v-if='choixAssure'>
  <Personne choixPersonne="choixAssure" @selectPersonne="selectionAssure"/>
</div>






  </div>
</template>

<script>
import { getPersons, savePerson, personsSearch, lienParentes, typeIdentites, nationalities } from '../services/ApiService.js'
export default {
  name: 'Personne',
  props: {
     choixPersonne :  {
      type: String,
      default: ''
    }
  },
  mounted() {

    lienParentes().then(response => {

       this.listLienParente = response.data;

   }).catch(err => this.showResponseError(err));

   typeIdentites().then(response => {

      this.listTypeIdentities = response.data;

  }).catch(err => this.showResponseError(err));


  nationalities().then(response => {

     this.listNationalities = response.data;

  }).catch(err => this.showResponseError(err));

  },
  data() {

       return {
           dateDebut: null,
           dateFin: null,
           listSearch: null,
           hasNext:false,
           hasPrevious:false,
           listLienParente: null,
           listTypeIdentities: null,
           listNationalities: null,
           addMode: false,
           choixAssure: '',
           choixFormBeneficiere: false,
           showMessageSucces: false,
           messageSucces: '',
           showMessageErreur: false,
           messagesErreur: [],

           formPersonne : {
              id:null,
              nom:'',
              prenom:'',
              cin:'',
              adresse:'',
              addressPrincipale:'',
              typeIdentite:null,
              nationalite:null,
              tel:'',
              email:'',
              dateNaissance:null,
              salarie:false,
              beneficieres: [],
              currPage: 0
           },

           formBeneficiere : {
             beneficiere : {
               id:0,
               nom:'',
               prenom:'',
               cin:'',
               adresse:'',
               tel:'',
               email:'',
               dateNaissance:null,

             },
             lienParente : {
               id:0,
               libelle:''
             }

          },

           fields: [
                {
                  key: "id",
                  label: "Id",

                },
                {
                  key: "nom",
                  label: "Nom",

                },
                {
                  key: "prenom",
                  label: "Prenom",

                },
                {
                  key: "cin",
                  label: "Cin/Passport",

                },
                {
                  key: "adresse",
                  label: "Adresse",

                },
                {
                  key: "tel",
                  label: "Tel",

                },
                {
                  key: "email",
                  label: "Email",

                },
                {
                  key: "dateNaissance",
                  label: "Date Naissance",

                },
                {
                  key: "salarie",
                  label: "Salarie",

                },
                { key: "actions" }
              ],
              fieldsBeneficiere: [
                {
                  key: "beneficiere.id",
                  label: "Id",

                },
                {
                  key: "beneficiere.nom",
                  label: "Nom",

                },
                {
                  key: "beneficiere.prenom",
                  label: "Prenom",

                },
                {
                  key: "beneficiere.cin",
                  label: "Cin/Passport",

                },
                {
                  key: "lienParente",
                  label: "Lien de parente",

                },
                { key: "actions" }

              ],
         }
       },

       methods : {

         chercher() {
           personsSearch(this.formPersonne).then(response => {

              this.listSearch = response.data.content;
              this.hasNext = response.data.hasNext;
              this.hasPrevious = response.data.hasPrevious;


      }).catch(err => this.showResponseError(err))
    },
    suivant() {
      this.formPersonne.currPage = this.formPersonne.currPage + 1;
      this.chercher();
    },
    precedent() {
      this.formPersonne.currPage = this.formPersonne.currPage - 1;
      this.chercher();
    },
    showFormAdd() {
      this.addMode = true
    },
    enregistrer() {
      if(!this.valdateForm()) {
        this.$refs["err_modal"].open();
        return;
      }
      savePerson(this.formPersonne).then((evt) => {
         this.fillFormO(evt.data);
         this.showMessageSucces = true;
         this.messageSucces = "Personne enregistree avec succe";
         this.$refs["err_modal"].open();

     }).catch(err => this.showResponseError(err));

    },
    annuler() {
      this.resetForm()
      this.addMode = false
      this.showMessageSucces = false
      this.showMessageErreur = false
    },
    resetForm() {
      this.formPersonne.id = null;
      this.formPersonne.nom = '';
      this.formPersonne.prenom = '';
      this.formPersonne.cin = null;
      this.formPersonne.adresse = null;
      this.formPersonne.addressPrincipale = null;
      this.formPersonne.typeIdentite = null;
      this.formPersonne.nationalite = null;
      this.formPersonne.tel = null;
      this.formPersonne.email = null;
      this.formPersonne.dateNaissance = null;
      this.salarie = false;
      this.beneficieres =[];
    },
    fillFormO(obj) {
      this.formPersonne.id = obj.id;
      this.formPersonne.nom = obj.nom;
      this.formPersonne.prenom = obj.prenom;
      this.formPersonne.cin = obj.cin;
      this.formPersonne.adresse = obj.adresse;
      this.formPersonne.addressPrincipale = obj.addressPrincipale;
      this.formPersonne.typeIdentite = obj.typeIdentite;
      this.formPersonne.nationalite = obj.nationalite;
      this.formPersonne.email = obj.email;
      this.formPersonne.dateNaissance = obj.dateNaissance;
      this.formPersonne.salarie = obj.salarie;
      this.formPersonne.beneficieres = obj.beneficieres;


    },
    fillForm(evts) {
      if(evts.length > 0) {
        this.fillFormO(evts[0]);
      } else {
        this.resetForm();
      }

    },

    valdateForm() {
      this.messagesErreur =[];
      if(!this.formPersonne.nom) {
        this.messagesErreur.push("Le nom est obligatoire");
      }
      if(!this.formPersonne.prenom) {
        this.messagesErreur.push("La prenom est obligatoire");
      }
      if(!this.formPersonne.cin) {
        this.messagesErreur.push("La cin/passport est obligatoire");
      }
      if(!this.formPersonne.adresse) {
        this.messagesErreur.push("L'adresse est obligatoire");
      }


      this.showMessageErreur = this.messagesErreur.length > 0 ;


      return !this.showMessageErreur;

    },

    update(data) {

      this.resetForm();

      getPersons(this.listSearch[data.index].id).then(response => {
         this.fillForm(response.data);
         this.showFormAdd();
      }).catch(err => this.showResponseError(err))


    },

    nouvelleDemande(data) {

      this.$emit('newOrder', this.listSearch[data.index].id);
    },

    choisirPersonne(data) {

      this.$emit('selectPersonne', this.listSearch[data.index].id);
    },

    retourPersonne() {

      this.$emit('selectPersonne', 0);
    },
    choisirBeneficiere() {
      this.choixAssure = 'B' ;
    },
    selectionAssure(idAssure) {
      if(idAssure === 0) {
         this.choixAssure = '' ;
      } else {
      getPersons(idAssure).then(response => {

         if(response.data.length > 0) {

             this.formBeneficiere.beneficiere = response.data[0];
             this.choixFormBeneficiere = true;


         }
         this.choixAssure = '' ;
      }).catch(err => this.showResponseError(err))
    }


    },

    ajouterBeneficiere() {
      var index = this.formPersonne.beneficieres.findIndex(x => x.beneficiere.id === this.formBeneficiere.beneficiere.id);
      if(index === -1 && this.formBeneficiere.beneficiere.id != this.formPersonne.id) {
       this.formPersonne.beneficieres.push({beneficiere:this.formBeneficiere.beneficiere, lienParente:this.formBeneficiere.lienParente});
      }
       this.choixFormBeneficiere = false;
    },
    annulerAjoutBeneficiere() {
       this.choixFormBeneficiere = false;
    },
    supprimerBeneficiere(data) {
      var id = this.formPersonne.beneficieres[data.index].beneficiere.id;
      var index = this.formPersonne.beneficieres.findIndex(x => x.beneficiere.id === id);
      if(index >= 0) {
        this.formPersonne.beneficieres.splice(index, 1);
      }
    },


    showResponseError(err) {
      this.messagesErreur =[];
      if(err.status === 403) {
        this.messagesErreur.push("Acces refuse");
      } else if(err.status === 409) {
        this.messagesErreur.push("Assure deja existant");
      } else {
        this.messagesErreur.push("Erreur technique");
      }
      this.showMessageErreur = true;
      this.$refs["err_modal"].open();
    },




       }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
